export const meta = {
  id: 'M04',
  slug: 'acompanhar-desenvolvimento',
  title: 'Como acompanhar o Desenvolvimento do Mentorado',
  description: 'Observe competências, objetivos, metas e evolução para identificar onde sua orientação pode gerar mais valor.',
  profile: 'mentor',
  category: 'desenvolvimento',
  type: 'task',
  status: 'published',
  order: 250,
  keywords: ['desenvolvimento', 'mentorado', 'competências', 'objetivos', 'metas', 'evolução'],
  previous: 'M03',
  next: 'M05',
  related: ['A03', 'M05', 'M07'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como acompanhar o Desenvolvimento do Mentorado

A visão de Desenvolvimento ajuda você a responder uma pergunta prática: **onde preciso prestar atenção agora?**

## O que observar

- competências em desenvolvimento;
- situação ou nível atual;
- objetivo principal;
- metas relacionadas;
- progresso e mudanças recentes;
- pontos de bloqueio ou baixa evolução.

## Como transformar informação em acompanhamento

<Steps>
  <Step title="Observe o momento atual">
    Identifique o que avançou, o que permanece estável e o que exige atenção.
  </Step>
  <Step title="Conecte ao objetivo">
    Verifique se o desenvolvimento observado continua coerente com aquilo que o mentorado quer alcançar.
  </Step>
  <Step title="Leve o ponto certo para a Mentoria">
    Priorize os temas que podem gerar uma decisão, uma ação ou um Acordo claro.
  </Step>
</Steps>

<Callout type="tip">
  Evite analisar cada indicador isoladamente. Competências, metas, Plano, Jornada, Evidências e Mentorias ganham mais significado quando vistos em conjunto.
</Callout>

<HelpImage alt="Desenvolvimento do mentorado na visão do Mentor" pendingId="M04.1" />
